import React from "react";

export default function About() {
  return (
    <div className="p-4">
      <h1>About Me</h1>
      <p>{/* Your About section content */}</p>
    </div>
  );
}
